import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { PageHeader } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { DailyCropSummaryTeaReportSchema } from "../DailyCropSummaryTeaReportSchema";
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import '../../../Common/Table/table.css';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import CreatePDF from './createPdf';
import ReactToPrint from "react-to-print";
import MessageModal from '../../../../UI/Modal/MessageModal';

const screenCode = 'DAILYCROPSUMMARYTEAREPORT'

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    },
    stickyHeader: {
        position: 'sticky',
        top: 0,
        zIndex: 1,
        backgroundColor: 'white',
    },
    stickyColumn: {
        position: 'sticky',
        left: 0,
        zIndex: 1,
        backgroundColor: 'white',
    },
});

export function DailyCropSummaryTeaReport(props) {

    const componentRef = useRef();
    const classes = useStyles();
    const schema = Joi.object(DailyCropSummaryTeaReportSchema).options({ allowUnknown: true });

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        operationEntityID: "0",
        month: new Date().toISOString().slice(0, 7)
    });
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "",
        disciption: "",
    });
    const [errors, setErrors] = useState({});
    const [reportData, setReportData] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [csvHeaders, setCsvHeaders] = useState([]);
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        collectionID: "",
        month: "",
    });
    const [daysArray, setDaysArray] = useState([]);
    const modifiedReportData = {};
    const [totalValues, setTotalValues] = useState({
        totalEstateCrop: 0,
        totalCashKilo: 0,
        totalOutSource: 0,
        totalECrop: 0,
        totalBoughtCrop: 0,
        totalCrop: 0,
        totalMadeTea: 0,
        totalGeneralPluckers: 0,
        totalAveragePluckers: 0,
        totalRainfall: 0
    });
    const [allowedOperationEntities, setAllowedOperationEntities] = useState([]);

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [searchData.groupID])

    useEffect(() => {
        setDaysArray(MonthDays(searchData.month));
    }, [searchData.month]);

    useEffect(() => {
        if (reportData.length != 0) {
            calculateTotal()
        }
    }, [reportData]);


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWDAILYCROPSUMMARYTEAREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromTokenV2();
        setAllowedOperationEntities(token.operationEntities || []);

        if (token.operationEntities.length > 0) {
            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }
            setMultipleEstates(estateArray)
        }
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getGroupsForDropDown();
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const opEntities = await service.getEstatesByGroupID(searchData.groupID);
        const allowedIDs = allowedOperationEntities.map(entity => entity.OperationEntityID);
        const filtered = Object.fromEntries(
            Object.entries(opEntities).filter(
                ([id, name]) => allowedIDs.includes(parseInt(id))
            )
        );
        setOperationEntity(filtered);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, DailyCropSummaryTeaReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        if (target.name === 'groupID') {
            setReportData([]);
            setsearchData({
                ...searchData,
                groupID: value,
                operationEntityID: "0",
                month: new Date().toISOString().slice(0, 7)
            });
        } else if (target.name === 'operationEntityID') {
            setReportData([]);
            setsearchData({
                ...searchData,
                operationEntityID: value,
                month: new Date().toISOString().slice(0, 7)
            });
        } else if (target.name === 'month') {
            setReportData([]);
            setsearchData({
                ...searchData,
                month: value
            });
        } else {
            setsearchData({
                ...searchData,
                [e.target.name]: value
            });
        }

        setErrors(error);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    async function handleSearch(e) {
        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;
        const reportData = await service.GetReportData(searchData.operationEntityID, searchData.month);
        if (reportData.length > 0) {
            setReportData(reportData)
            setSelectedSearchData();
            reportData.forEach(row => {
                const { day } = row;
                if (!modifiedReportData[day]) {
                    modifiedReportData[day] = [row];
                } else {
                    modifiedReportData[day].push(row);
                }
            });
        } else {
            setMessageModel({
                ...messageModel,
                hidden: false,
                type: "Error",
                disciption: "No Records To Display",
            });
            setTimeout(() => {
                modalDismissHandler();
            }, 3000);
        }
    }

    function calculateTotal() {

        const totalCashKilo = reportData.reduce((accumulator, current) => {
            const progressFraction = current.cashKilo;
            return accumulator + progressFraction;
        }, 0);

        const totalOutSource = reportData.reduce((accumulator, current) => {
            const progressFraction = current.outSource;
            return accumulator + progressFraction;
        }, 0);

        const totalECrop = reportData.reduce((accumulator, current) => {
            const progressFraction = Math.floor(current.estateCrop);
            return accumulator + progressFraction;
        }, 0);

        const totalEstateCrop = reportData.reduce((accumulator, current) => {
            const cropTotal = parseFloat(getEstateCrop(current));
            return accumulator + cropTotal;
        }, 0);

        const totalBoughtCrop = reportData.reduce((accumulator, current) => {
            const boughtCrop = Math.max(0, current.boughtCrop);
            const boughtCropInteger = Math.floor(boughtCrop);

            return accumulator + boughtCropInteger;
        }, 0);

        const totalCrop = reportData.reduce((accumulator, current) => {
            const cropTotal = parseFloat(getCrop(current));
            return accumulator + cropTotal;
        }, 0);

        const totalGeneralPluckers = reportData.reduce((accumulator, current) => {
            const progressFraction = current.generalPluckers;
            return accumulator + progressFraction;
        }, 0);

        const totalAveragePluckers = reportData.reduce((accumulator, current) => {
            const averagePluckers = totalEstateCrop / totalGeneralPluckers;
            return averagePluckers;
        }, 0);

        const totalMadeTea = reportData.reduce((accumulator, current) => {
            const madeTea = parseFloat(getMadeTea(current));
            return accumulator + madeTea;
        }, 0);

        const totalRainfall = reportData.reduce((accumulator, current) => {
            const progressFraction = current.rainfall;
            return accumulator + progressFraction;
        }, 0);

        setTotalValues({
            ...totalValues,
            totalEstateCrop: totalEstateCrop,
            totalCashKilo: totalCashKilo,
            totalOutSource: totalOutSource,
            totalECrop: totalECrop,
            totalBoughtCrop: totalBoughtCrop,
            totalCrop: totalCrop,
            totalMadeTea: totalMadeTea,
            totalGeneralPluckers: totalGeneralPluckers,
            totalAveragePluckers: totalAveragePluckers,
            totalRainfall: totalRainfall
        });
    }

    function setSelectedSearchData() {
        const estateName = operationEntity[searchData.operationEntityID] || '';
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchData.groupID],
            estate: estateName,
            month: searchData.month
        })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var totalCropFormatted = getCrop(x);
                var estateCrop = getEstateCrop(x);
                var averagePerPlucker = isNaN(estateCrop / x.generalPluckers) ? '0' : (estateCrop / x.generalPluckers).toFixed(2);

                if (!isFinite(averagePerPlucker)) {
                    averagePerPlucker = '0';
                }

                var estateCropAdjusted = x.estateCrop < 0 ? 0 : Math.floor(x.estateCrop);
                var boughtCropFormatted = Math.floor(x.boughtCrop).toLocaleString();
                var madeTea = getMadeTea(x);

                var vr = {
                    'Date': x.day,
                    'Estate Crop (Kgs)': estateCrop,
                    'Cash Kilos': x.cashKilo,
                    'Outsource Crop (Kgs)': x.outSource,
                    'Total Estate Crop (Kgs)': estateCropAdjusted,
                    'Bought Crop (Kgs)': boughtCropFormatted,
                    'Total Crop (Kgs)': totalCropFormatted,
                    'Made Tea (Kgs)': madeTea.toFixed(2),
                    'Man days of Checkroll Pluckers': x.generalPluckers,
                    'Average per Plucker': averagePerPlucker,
                    'Rainfall (mm)': x.rainfall
                };
                res.push(vr);
            });

            var totalMadeTea = totalValues.totalMadeTea;
            var totalAveragePerPlucker = totalValues.totalAveragePluckers;
            var boughtCropTotalFormatted = Math.floor(totalValues.totalBoughtCrop).toLocaleString();
            var totalCropTotalFormatted = Math.floor(totalValues.totalCrop).toLocaleString();

            if (!isNaN(totalAveragePerPlucker)) {
                totalAveragePerPlucker = totalAveragePerPlucker.toFixed(2);
            } else {
                totalAveragePerPlucker = '0';
            }

            var vr = {
                'Date': 'Total',
                'Estate Crop (Kgs)': Math.floor(totalValues.totalEstateCrop),
                'Cash Kilos': Math.floor(totalValues.totalCashKilo),
                'Outsource Crop (Kgs)': Math.floor(totalValues.totalOutSource),
                'Total Estate Crop (Kgs)': Math.floor(totalValues.totalECrop),
                'Bought Crop (Kgs)': boughtCropTotalFormatted,
                'Total Crop (Kgs)': totalCropTotalFormatted,
                'Made Tea (Kgs)': totalMadeTea.toFixed(2),
                'Man days of Checkroll Pluckers': totalValues.totalGeneralPluckers.toFixed(2),
                'Average per Plucker': totalAveragePerPlucker,
                'Rainfall (mm)': totalValues.totalRainfall
            };
            res.push(vr);
            res.push([]);

            var vr = {
                'Date': 'Group : ' + selectedSearchValues.group,
                'Estate Crop (Kgs)': 'Operation Entity : ' + selectedSearchValues.estate,
                'Cash Kilos': 'Month : ' + selectedSearchValues.month,
            };
            res.push(vr);
        }
        return res;
    }

    async function createFile() {
        var file = await createDataForExcel(reportData);

        var settings = {
            sheetName: 'Daily Crop Summary - Tea Report',
            fileName: 'Daily Crop Summary - Tea Report',
            writeOptions: {}
        };

        let keys = Object.keys(file[0]);
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem });
        });

        xlsx(csvHeaders, file, settings, true);
    }

    function MonthDays(month) {
        const year = parseInt(moment(month, "YYYY-MM").format('YYYY'));
        const monthNumber = parseInt(moment(month, "YYYY-MM").format('M')) - 1;

        function daysInMonth(year, month) {
            return new Date(year, month + 1, 0).getDate();
        }

        const totalDays = daysInMonth(year, monthNumber);
        const daysArray = Array.from({ length: totalDays }, (_, i) => i + 1);
        return daysArray;
    }

    const getCrop = (row) => {
        const estateCrop = row.estateCrop;
        const cashKilo = row.cashKilo;
        const outSource = row.outSource;
        const boughtCrop = row.boughtCrop;
        const newEstateCrop = Math.max(0, Math.floor(estateCrop - cashKilo - outSource));
        const total = Math.floor(newEstateCrop + cashKilo + outSource + boughtCrop);

        return total;
    }

    const getEstateCrop = (row) => {
        const estateCrop = row.estateCrop;
        const cashKilo = row.cashKilo;
        const outSource = row.outSource;
        const newEstateCrop = Math.floor(Math.max(0, estateCrop - cashKilo - outSource));

        return newEstateCrop;
    }

    const getAveragePerPlucker = (row) => {
        const estateCrop = getEstateCrop(row);
        const generalPluckers = row.generalPluckers;
        const averagePerPlucker = estateCrop / generalPluckers;

        return averagePerPlucker;
    }

    const getMadeTea = (row) => {
        const madeTea = getCrop(row) / 100 * row.outturn;
        return madeTea;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Daily Crop Summary - Tea Report"
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                        {generateDropDownMenu(operationEntity)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <TextField
                                        id="month"
                                        label="Month *"
                                        name="month"
                                        type="month"
                                        fullWidth
                                        value={searchData.month}
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["month"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["month"]}</FormHelperText>}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </div>
                            {reportData.length > 0 ?
                                <TableContainer component={Paper} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", maxHeight: '800px', overflowY: 'auto' }}>
                                    <Table className={classes.table} style={{ borderCollapse: 'collapse', border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} size="small" aria-label="sticky table" stickyHeader>
                                        <TableHead className={`${classes.stickyHeader}`}>
                                            <TableRow className={`${classes.stickyHeader}`} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }}>
                                                <TableCell className={`${classes.stickyHeader}`} align="center" rowSpan={2} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Date
                                                </TableCell>
                                                <TableCell className={`${classes.stickyHeader}`} align="center" colSpan={7} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Green Leaf Details
                                                </TableCell>
                                                <TableCell className={`${classes.stickyHeader}`} align="center" rowSpan={2} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Made       Tea             (Kgs)
                                                </TableCell>
                                                <TableCell className={`${classes.stickyHeader}`} align="center" rowSpan={2} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Man days of Checkroll Pluckers
                                                </TableCell>
                                                <TableCell className={`${classes.stickyHeader}`} align="center" rowSpan={2} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Average              per               Plucker
                                                </TableCell>
                                                <TableCell className={`${classes.stickyHeader}`} align="center" rowSpan={2} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Rainfall                        (mm)
                                                </TableCell>
                                            </TableRow>
                                            <TableRow className={`${classes.stickyHeader}`} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }}>
                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Estate Crop         (Kgs)
                                                </TableCell>
                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Cash  Kilos
                                                </TableCell>
                                                <TableCell align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Outsource      Crop (Kgs)
                                                </TableCell>
                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Total Estate   Crop (Kgs)
                                                </TableCell>
                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Bought         Crop (Kgs)
                                                </TableCell>
                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Marginal                                                  Crop
                                                </TableCell>
                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Total Crop          (Kgs)
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {reportData.map(row => (
                                                <TableRow >
                                                    <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="center">
                                                        {row.day}
                                                    </TableCell>
                                                    <React.Fragment >
                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                            {getEstateCrop(row) === 0 ? '-' : getEstateCrop(row)}
                                                        </TableCell>
                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                            {row.cashKilo == 0 ? '-' : Math.floor(row.cashKilo)}
                                                        </TableCell>
                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                            {row.outSource == 0 ? '-' : Math.floor(row.outSource)}
                                                        </TableCell>
                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                            {row.estateCrop == 0 ? '-' : Math.floor(row.estateCrop)}
                                                        </TableCell>
                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                            {Math.floor(row.boughtCrop) == 0 ? '-' : Math.floor(row.boughtCrop)}
                                                        </TableCell>
                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                            {/*Marginal Crop*/}
                                                        </TableCell>
                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                            {getCrop(row) == 0 ? '-' : getCrop(row)}
                                                        </TableCell>
                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                            {(getMadeTea(row)) == 0 ? '-' : (getMadeTea(row)).toFixed(2)}
                                                        </TableCell>
                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                            {(row.generalPluckers) == 0 ? '-' : (row.generalPluckers)}
                                                        </TableCell>
                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                            {
                                                                isNaN(getAveragePerPlucker(row)) || !isFinite(getAveragePerPlucker(row)) ?
                                                                    ' - ' : getAveragePerPlucker(row).toFixed(2)
                                                            }
                                                        </TableCell>
                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                            {(row.rainfall).toFixed(2) == 0 ? '-' : (row.rainfall).toFixed(2)}
                                                        </TableCell>
                                                    </React.Fragment>
                                                </TableRow>
                                            ))}
                                        </TableBody>

                                        <TableBody>
                                            <TableRow style={{ border: "2px solid black" }}>
                                                <TableCell style={{ borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="left">
                                                    Total
                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                    {Math.floor(totalValues.totalEstateCrop).toLocaleString()}
                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                    {Math.floor(totalValues.totalCashKilo).toLocaleString()}
                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                    {Math.floor(totalValues.totalOutSource).toLocaleString()}
                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                    {Math.floor(totalValues.totalECrop).toLocaleString()}
                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                    {Math.floor(totalValues.totalBoughtCrop).toLocaleString()}
                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                    {/*total marginal*/}
                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                    {Math.floor(totalValues.totalCrop).toLocaleString()}
                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                    {totalValues.totalMadeTea.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                    {totalValues.totalGeneralPluckers.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                    {isNaN(totalValues.totalAveragePluckers) ? (0).toFixed(2) : totalValues.totalAveragePluckers.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                    {totalValues.totalRainfall.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow style={{ border: "2px solid black" }}>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="center">
                                                    VP Extent
                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>

                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>

                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>

                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                            </TableRow>
                                            <TableRow style={{ border: "2px solid black" }}>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="center">
                                                    Seedling Extent
                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>

                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>

                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>

                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                            </TableRow>
                                            <TableRow style={{ border: "2px solid black" }}>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="center">
                                                    Total Extent
                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>

                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>

                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>

                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                            </TableRow>
                                            <TableRow style={{ border: "2px solid black" }}>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="center">
                                                    Out grower Extent
                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>

                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>

                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>

                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                            </TableRow>
                                            <TableRow style={{ border: "2px solid black" }}>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="center">
                                                    YPH
                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>

                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>

                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>

                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTop: '2px solid black', borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                            </TableRow>
                                            <TableRow style={{ border: "2px solid black" }}>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="center">
                                                    Last Year
                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>

                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>

                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>

                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">

                                                </TableCell>
                                            </TableRow>

                                        </TableBody>
                                    </Table>
                                </TableContainer> : null}
                        </form>
                        {
                            (reportData.length == 0 || reportData == undefined || reportData == null || reportData == []) ?
                                null : <div className="pt-3">
                                    <div>&nbsp;</div>
                                    <style>
                                        {`
                                            @page {
                                                size: A4 portrait;
                                                margin: 15mm;
                                            }
                                        `}
                                    </style>
                                    <ReactToPrint
                                        trigger={() => <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Create PDF"
                                        />}
                                        content={() => componentRef.current}
                                        documentTitle={'Daily Crop Summary - Tea Report'}
                                    />
                                    <div hidden={true}>
                                        <CreatePDF ref={componentRef} reportData={reportData}
                                            selectedSearchValues={selectedSearchValues} totalValues={totalValues} daysArray={daysArray} />
                                    </div>
                                    <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="Excel"
                                        onClick={createFile}
                                    />
                                </div>
                        }
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment >
    );
}